export const AccountManagerSessionStorage = {
  setConnectedAccountManagerName: async (name: string) => {
    try {
      await sessionStorage.setItem("walletName", name);
      return true;
    } catch (e) {
      throw e;
    }
  },
  getConnectedAccountManagerName: async () => {
    try {
      return await sessionStorage.getItem("walletName");
    } catch (e) {
      throw e;
    }
  },
  deleteConnectedAccountManagerName: async () => {
    try {
      return await sessionStorage.removeItem("walletName");
    } catch (e) {
      throw e;
    }
  },
};
